<template>
  <v-container>
    <v-row justify="center">
      <v-col :cols="12" :sm="9" :md="10" :lg="11" :xl="8" class="py-0 px-0">
        <v-card flat>
          <v-container class="py-0">
            <v-row>
              <v-col :cols="8" class="pb-0 pl-4">
                <span
                  style="font-family: explorerTitleFont;font-size:20px;font-weight:600;"
                  >Transaction Detail</span
                >
              </v-col>
              <v-col :cols="10" class="pt-1 pb-3 pl-4">
                <p
                  style="font-size:14px;font-weight:400;"
                  class="mb-0 grey--text"
                >
                  {{ transactionId }}
                </p>
              </v-col>
            </v-row>
          </v-container>

          <List-View
            :limit="txAttributes.length"
            :attributes="txAttributes"
            :links="txLinks"
            class="pt-0"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ListView from "../material/ListView.vue";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    ListView
  },
  data() {
    return {
      transactionId: "",
      transactionInfo: {},
      apiUrl: `${this.$config.apiEndPoint}/token/transaction/${this.$router.currentRoute.params.transactionId}`,
      txAttributes: [
        { text: "Type", value: "functionIndexType", type: "head_capitalize" },
        { text: "Contract ID", value: "contractId" },
        { text: "Timestamp", value: "timestamp", type: "timestamp" },
        { text: "Block Height", value: "height", type: "thousands" },
        {
          text: "Comfirmed Blocks",
          value: "confirmations",
          type: "confirmations"
        },
        { text: "Sender", value: "signer", type: "address" },
        { text: "Recipient", value: "recipient", type: "address" },
        { text: "Amount", value: "amount", type: "transform_unity" },
        { text: "Unity", value: "unity", type: "thousands" },
        { text: "Fee (VSYS)", value: "transactionFee", type: "thousands" },
        { text: "Status", value: "status" },
        { text: "Attachment", value: "attachment" }
      ],
      txLinks: {
        recipient: "/address/:address",
        signer: "/address/:address"
      },
      heightApis: {
        mainnet: "https://wallet.v.systems/api/blocks/height",
        testnet: "https://test.v.systems/api/blocks/height"
      }
    };
  },
  computed: {
    ...mapState(["queryAnswer", "tokenInfo"])
  },
  async created() {
    this.transactionId = this.$route.params.transactionId;
    let errorMsg = "Connection failed!Please check Internet connection.";
    try {
      if (!this.transactionId || this.transactionId.length === 0) {
        errorMsg =
          "Transaction ID cannot be empty. Please input valid transaction ID.";
        throw new Error("Error: Wrong parameter.");
      }
      await this.getCurBlockHeight();
      const res = await this.$http.get(this.apiUrl);
      if (res && res.data && res.data.result) {
        if (res.data.result.tokenId !== this.tokenInfo.tokenId) {
          errorMsg = `This token does not have the transaction. Please view it in related explorer.`;
          throw new Error(
            "Error: This transaction does not involve in this token."
          );
        } else {
          let result = res.data.result;
          result.unity = this.tokenInfo.unity;
          this.updateQueryAnswer(result);
        }
      } else {
        errorMsg =
          res && res.data && !res.data.result
            ? "This transaction ID did not involve in activities of the token."
            : errorMsg;
        throw new Error("Error: Cannot get data from remote.");
      }
    } catch (e) {
      this.updateShowError(true);
      if (e.response && e.response.status && e.response.status === 404) {
        errorMsg = "This data does not exist in db";
      } else if (e.code === "ECONNABORTED") {
        errorMsg =
          "Time out! Please check Internet connection or try again later.";
      }
      this.updateErrorMsg(errorMsg);
    }
  },
  methods: {
    ...mapMutations([
      "updateQueryAnswer",
      "updateShowError",
      "updateErrorMsg",
      "updateCurBlockHeight"
    ]),
    // get block height from any one of node list.
    async getCurBlockHeight() {
      const nets = ["mainnet", "testnet"];
      const net = nets.includes(this.$config.net)
        ? this.$config.net
        : "mainnet";
      const api = this.heightApis[net];
      try {
        const res = await this.$http.get(api);
        if (res && res.data && res.data.height) {
          this.updateCurBlockHeight(res.data.height);
        } else {
          this.updateShowError(true);
          this.updateErrorMsg("Cannot get node height from remote");
          throw new Error("Error: Cannot get data from remote");
        }
      } catch {
        // catch error
      }
    }
  }
};
</script>
>
<style>
.id_font {
  color: #9e9e9e;
}
@font-face {
  /* font-properties */
  font-family: explorerTitleFont;
  src: url("../../assets/font/SF-Pro-Display-Semibold.otf");
}
</style>
>
